// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + "85eff8437eb9d2f7d42f" + ".chunk.js";
};